export default {"src":"/_next/static/media/bnb.8bf81f2a.svg","height":2496,"width":2496,"blurWidth":0,"blurHeight":0};